import * as blockConstants from "./constants";

export const blockButtonsModel = {
    [blockConstants.BLOCK_BUTTON_TITLE_RU]: "",
    [blockConstants.BLOCK_BUTTON_TITLE_EN]: "",
    [blockConstants.BLOCK_BUTTON_LINK]: "",
    [blockConstants.BLOCK_BUTTON_TYPE]: blockConstants.BLOCK_BUTTON_TYPE_CUSTOM,
    [blockConstants.BLOCK_BUTTON_OPTIONS]: {
        type: "filled",
    },
    [blockConstants.BLOCK_BUTTON_QUIZ_KEY]: "",
};

export const blockCalendarModel = {
    [blockConstants.BLOCK_ACTIVITIES_PLATFORM_LINK_ONLINE]: false,
    [blockConstants.BLOCK_ACTIVITIES_PLATFORM_LINK_OFFLINE]: false,
    [blockConstants.BLOCK_ACTIVITIES_EVENT_ADDRESS]: "",
};

export const blockModel = {
    [blockConstants.BLOCK_NAME]: "",
    [blockConstants.BLOCK_TYPE]: blockConstants.BLOCK_TYPE_CUSTOM,
    [blockConstants.BLOCK_SHOW_TITLE]: true,
    [blockConstants.BLOCK_TITLE_EN]: "",
    [blockConstants.BLOCK_TITLE_RU]: "",
    [blockConstants.BLOCK_DESCRIPTION_RU]: "",
    [blockConstants.BLOCK_DESCRIPTION_EN]: "",
    [blockConstants.BLOCK_DESCRIPTION]: "",
    [blockConstants.BLOCK_BUTTONS]: [],
    [blockConstants.BLOCK_WATCH_ONLINE]: false,
    [blockConstants.BLOCK_CHECK_CONNECTION]: false,
    [blockConstants.BLOCK_OFFLINE_PLATFORM]: false,
    [blockConstants.BLOCK_ACTIVITIES]: [],
};

export const blockTypeOptions = {
    [blockConstants.BLOCK_TYPE_GREETING]: "Приветственный блок",
    [blockConstants.BLOCK_TYPE_MAIN_INFO_ONLINE]:
        "Информация для онлайн участника",
    [blockConstants.BLOCK_TYPE_MAIN_INFO_OFFLINE]:
        "Информация для офлайн участника",
    [blockConstants.BLOCK_TYPE_ORGANIZER_CONTACTS]: "Контакты",
    [blockConstants.BLOCK_TYPE_CALENDAR_ONLINE]: "Календарь онлайн",
    [blockConstants.BLOCK_TYPE_CALENDAR_OFFLINE]: "Календарь офлайн",
    [blockConstants.BLOCK_TYPE_DISCLAIMER]: "Дисклеймер",
    [blockConstants.BLOCK_TYPE_CUSTOM]: "Настраиваемый блок",
    [blockConstants.BLOCK_TYPE_PASSWORD]: "Пароль",
    [blockConstants.BLOCK_TYPE_QUESTIONNAIRE]: "Опрос",
    [blockConstants.BLOCK_TYPE_CERTIFICATE]: "Сертификат",
    [blockConstants.BLOCK_TYPE_QRCODE_OFFLINE]: "QR код для доступа на офлайн мероприятие",
};

export const blockButtonsType = {
    [blockConstants.BLOCK_BUTTON_TYPE_CUSTOM]: "Новая кнопка",
    [blockConstants.BLOCK_BUTTON_TYPE_CHECK_CONNECTION]:
        "Проверить подключение",
    [blockConstants.BLOCK_BUTTON_TYPE_WATCH_BROADCAST_ONLINE]:
        "Смотреть трансляцию онлайн",
    [blockConstants.BLOCK_BUTTON_TYPE_OPEN_OFFLINE_PLATFORM]:
        "Открыть платформу офлайн участника",
    [blockConstants.BLOCK_BUTTON_TYPE_QUIZ]: "Перейти в квиз",
};
